import {
  Body1,
  Col,
  Grid,
  GridVariant,
  Heading1,
  Link,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react';
import { GetServerSideProps } from 'next';
import React from 'react';
import { Card } from '../../components/Card/Card';
import { InternalLink } from '../../components/InternalLink/InternalLink';
import { middleColumnLayout } from '../../components/page-layouts/columnLayouts';
import { getAllFeatureFlags } from '../../utils/feature-flags';

// To retire this page once a real destination ships, re-point the link in navConfig instead.
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const features = await getAllFeatureFlags(ctx.query);

  if (!features.enable_homepage_redesign) {
    return { notFound: true };
  }

  return { props: {} };
};

export default function Placeholder() {
  return (
    <Grid variant={GridVariant.Layout}>
      <Col gridColumn={middleColumnLayout} paddingV={8}>
        <Card>
          <Heading1 textAlign={TextAlign.Center}>Coming soon</Heading1>
          <Space size={4} />
          <Body1 textAlign={TextAlign.Center}>
            This page isn&apos;t ready yet — check back soon.
          </Body1>
          <Space size={6} />
          <InternalLink href="/">
            <Link href="/">Back to the homepage</Link>
          </InternalLink>
        </Card>
      </Col>
    </Grid>
  );
}
